// extracted by mini-css-extract-plugin
module.exports = {"Header":"style_Header__3aKLn","Footer":"style_Footer__2d4uR"};